import { dateToString } from './dateToString'
import { subjectType } from '../../strings/types'

export const normalizeIndividualSubject = (data, id, subject_type) => {
  const first_name = data[`subj_first_name_${id}`]
  const middle_name = data[`subj_middle_name_${id}`]
  const last_name = data[`subj_last_name_${id}`]
  const suffix = data[`subj_suffix_${id}`]
  const individual_category = data[`subj_individual_category_${id}`]
  const alias_nickname = data[`subj_alias_nickname_${id}`]
  const home_phone = data[`subj_home_phone_${id}`]
  const cell_phone = data[`subj_cell_phone_${id}`]
  const work_phone = data[`subj_work_phone_${id}`]
  const employer = data[`subj_employer_${id}`]
  const employer_phone = data[`subj_employer_phone_${id}`]
  const employer_address = data[`subj_employer_address_${id}`]
  const personal_email = data[`subj_personal_email_${id}`]
  const work_email = data[`subj_work_email_${id}`]
  const address = data[`subj_address_${id}`]
  const dob = data[`subj_dob_${id}`]
  const job_title = data[`subj_job_title_${id}`]
  const physical_description = data[`subj_physical_description_${id}`]
  const relationship = data[`subj_relationship_${id}`]
  const relationship_other = data[`subj_relationship_other_${id}`]

  return {
    subject_type,
    first_name,
    middle_name,
    last_name,
    suffix,
    category: individual_category,
    alias: alias_nickname,
    email: personal_email,
    dob: dob && dateToString(dob),
    description: physical_description,
    phone: cell_phone,
    phone2: home_phone,
    address: address && address.line1Value,
    address2: address && address.line2Value,
    city: address && address.cityValue,
    state: address && address.stateValue,
    zip: address && address.zipValue,
    country: address && address.countryValue,
    relationship: relationship,
    relationship_other: relationship_other,
    employment: {
      employer,
      job_title,
      address: employer_address && employer_address.line1Value,
      address2: employer_address && employer_address.line2Value,
      city: employer_address && employer_address.cityValue,
      state: employer_address && employer_address.stateValue,
      zip: employer_address && employer_address.zipValue,
      country: employer_address && employer_address.countryValue,
      phone: employer_phone,
      phone2: work_phone,
      email: work_email
    }
  }
}

export const normalizeBusinessSubject = (data, id, subject_type) => {
  const business_name = data[`subj_business_name_${id}`]
  const business_category = data[`subj_business_category_${id}`]
  const business_dba = data[`subj_business_dba_${id}`]
  const alternate_phone = data[`subj_alternate_phone_${id}`]
  const business_phone = data[`subj_business_phone_${id}`]
  const business_address = data[`subj_business_address_${id}`]
  const business_employer_id = data[`subj_business_employer_id_${id}`]
  const business_npi = data[`subj_business_npi_${id}`]
  const additional_identifying_information =
    data[`additional_identifying_information_${id}`]
  const website = data[`subj_website_${id}`]

  return {
    subject_type,
    business_name,
    business_category,
    dba: business_dba,
    ein: business_employer_id,
    npi: business_npi,
    phone: business_phone,
    phone2: alternate_phone,
    website,
    address: business_address && business_address.line1Value,
    address2: business_address && business_address.line2Value,
    city: business_address && business_address.cityValue,
    state: business_address && business_address.stateValue,
    zip: business_address && business_address.zipValue,
    country: business_address && business_address.countryValue,
    description: additional_identifying_information
  }
}

/**
 * There are two layers of validation for subject page data. The first verifies that a subject type
 * exists (for when the user has the option to choose between the two). The second verfies that a
 * subject has the required field filled out (allows the dev to force a particular subject_type).
 *
 * @param {object} data
 * @param {int} maxIndex
 * @param {int} index
 */
export const normalizeSubjectData = (data, maxIndex = 0, index = 0) => {
  let subjects = []

  for (let id = index; id <= maxIndex; id++) {
    const subject_type = data[`subject_type_${id}`]

    switch (subject_type) {
      case subjectType.business:
        if (data[`subj_business_name_${id}`].length > 0)
          subjects.push(normalizeBusinessSubject(data, id, subject_type))
        break
      case subjectType.individual:
      case subjectType.singleIndividual:
        if (data[`subj_first_name_${id}`].length > 0)
          subjects.push(normalizeIndividualSubject(data, id, subject_type))
        break
      default:
        break
    }
  }

  return subjects
}
